import React, { Component } from 'react'
import { ResponsivePie } from '@nivo/pie'
import './ChartPie.scss'
import {colours} from '../../../config'

const data = [
  {
    "id": "c",
    "label": "c",
    "value": 563,
    "color": "hsl(256, 70%, 50%)"
  },
  {
    "id": "php",
    "label": "php",
    "value": 311,
    "color": "hsl(273, 70%, 50%)"
  }
]

class ChartPie extends Component {

    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {



        return (
          <div style={{height: this.props.height}}>
            <ResponsivePie
                data={this.props.data}
                margin={{
                    "top": 40,
                    "right": 40,
                    "bottom": 40,
                    "left": 40
                }}
                innerRadius={0.5}
                padAngle={0}
                cornerRadius={1}
                colors={colours}
                colorBy="id"
                borderWidth={1}
                borderColor="inherit:darker(0.2)"
                radialLabelsSkipAngle={10}
                radialLabelsTextXOffset={6}
                radialLabelsTextColor="#999"
                radialLabelsLinkOffset={0}
                radialLabelsLinkDiagonalLength={10}
                radialLabelsLinkHorizontalLength={5}
                radialLabelsLinkStrokeWidth={1}
                radialLabelsLinkColor="inherit"
                slicesLabelsSkipAngle={10}
                slicesLabelsTextColor="#fff"
                animate={true}
                motionStiffness={90}
                motionDamping={15}
                theme={{
                    "tooltip": {
                        "container": {
                            "fontSize": "13px"
                        }
                    },
                    "labels": {
                        "textColor": "#555"
                    }
                }}


            />
          </div>
        )
    }
}

// legends={[
//     {
//         "anchor": "bottom",
//         "direction": "row",
//         "translateY": 56,
//         "itemWidth": 100,
//         "itemHeight": 18,
//         "symbolSize": 18,
//         "symbolShape": "circle"
//     }
// ]}

export default ChartPie



// WEBPACK FOOTER //
// ./src/views/components/ChartPie/index.js